export default __webpack_public_path__ + "static/media/pic3.1c16c04f.jpg";